import { createStore, applyMiddleware } from 'redux'
import reducer from 'reducers/account'

const logger = store => next => action => {
  console.group(action.type)
  console.info('dispatching', action)
  const result = next(action)
  console.log('next state', store.getState())
  console.groupEnd()
  return result
}

const initialState = {
  modal: {
    id: null,
    open: false
  },
  errorMessage: null,
  notifications: [],
  billing: {
    // null = not yet loaded; UI guards with `queryLoading || !refundRecipientForm`
    refundRecipientForm: null
  },
  // Entity edit forms are initialized as {} (not null) so that field-level
  // setCamperFormField/etc. actions can safely merge into them before the query
  // completes. The UI must NOT use `!form` as a load gate here — that only works
  // with null. Instead, use `queryLoading || (!form.id && !!entity)`, which
  // correctly handles three states: loading, entity not found, and entity loaded.
  campers: {
    form: {}
  },
  parents: {
    form: {}
  },
  emergencyContacts: {
    form: {}
  },
  pickupPeople: {
    form: {}
  },
  account: {
    // null = not yet loaded; UI guards with `!form || queryLoading`
    form: null
  },
  cart: {
    // null = not yet loaded; UI guards with `!cartForm || queryLoading`
    cartForm: null
  },
  checkout: {
    paymentMethod: null,
    // null = not yet loaded; UI guards with `queryLoading || !paymentProfileForm`
    paymentProfileForm: null
  },
  // TODO: move all form state here
  forms: {
    weekReservationsForm: [],
    waiverForms: [],
    eciForm: {
      location: null,
      lunchOption: null,
      lunchNotes: null,
      lastAttendanceId: null,
      lastAttendanceRating: null
    }
  }
}

const middleware = []
if (process.env.NODE_ENV === 'development') {
  middleware.push(logger)
}

const store = createStore(reducer, initialState, applyMiddleware(...middleware))

export default store
